import './App.scss';
import React from "react";
import Footer from "./components/footer";
import {HashRouter as Router, Routes, Route} from "react-router-dom";
import MainPage from "./components/main-page"
import AboutMeLongVersion from "./components/about-me-long-version";
import SideBar from "./components/side-bar";
import Sales from "./components/sales";
import Opinion from "./components/opinion";
import Registration from "./components/registration";
import Faq from "./components/faq";
import InfoModal from "./components/info-modal";

function App() {
    return (
        <div className={'main-container'}>
            <Router>
                <SideBar/>
                <InfoModal/>
                <Routes>
                    <Route path="/" element={<MainPage/>}/>
                    <Route path="about" element={<AboutMeLongVersion/>}/>
                    <Route path="sales" element={<Sales/>}/>
                    <Route path="faq" element={<Faq/>}/>
                    <Route path="opinion" element={<Opinion/>}/>
                    <Route path="register" element={<Registration/>}/>
                </Routes>
            </Router>
            <Footer/>
        </div>
    );
}

export default App;
